export interface Segment{
    id: number;
    name: string;
    productTypeId?: number;
    isEdited?: boolean;
    segmentType?: string;
    description?: string;
}

export interface ProductType{
name: string;
productTypeId?: number;
clientTypeId: number;
description?: string;
segmentations?: Segment[]
}

export const ISegment = {
    getDefault(): Segment {
      return {
        name: '',
        id: 0,
        description: '',
        segmentType: ''
      };
    },
  };